// SOP系统常量
export const SOP_CONSTANTS = {
  TemplateStatus: {
    DRAFT: 'draft',
    ACTIVE: 'active',
    INACTIVE: 'inactive'
  },
  TargetType: {
    CUSTOMER: 'CUSTOMER',
    GROUP: 'GROUP'
  },
  TriggerType: {
    TAG_CHANGE: 'TAG_CHANGE',
    MANUAL: 'MANUAL',
    SCHEDULED: 'SCHEDULED'
  },
  StepType: {
    MESSAGE: 'MESSAGE',
    MOMENTS: 'MOMENTS',
    TAG: 'TAG'
  },
  ActionType: {
    // 通用动作类型
    SEND_MESSAGE: 'SEND_MESSAGE',
    SEND_MOMENT: 'SEND_MOMENT',
    UPDATE_TAG: 'UPDATE_TAG',
    
    // 消息类型
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    IMAGE_GROUP: 'IMAGE_GROUP',
    VIDEO: 'VIDEO',
    LINK: 'LINK',
    MINIPROGRAM: 'MINIPROGRAM',
    FILE: 'FILE',
    // 朋友圈类型
    MOMENT_TEXT: 'MOMENT_TEXT',
    MOMENT_IMAGE: 'MOMENT_IMAGE',
    MOMENT_IMAGE_GROUP: 'MOMENT_IMAGE_GROUP',
    MOMENT_VIDEO: 'MOMENT_VIDEO',
    MOMENT_LINK: 'MOMENT_LINK',
    // 标签类型
    ADD_TAG: 'ADD_TAG',
    REMOVE_TAG: 'REMOVE_TAG'
  },
  Operation: {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    ANY_CHANGE: 'ANY_CHANGE'
  }
};

// 目标类型选项
export const targetTypes = [
  { value: 'CUSTOMER', label: '客户' },
  { value: 'GROUP', label: '客户群' }
];

// 触发类型选项
export const triggerTypes = [
  { value: 'TAG_CHANGE', label: '标签变更' },
  { value: 'MANUAL', label: '手动触发' },
  { value: 'SCHEDULED', label: '定时触发' }
];

// 步骤类型选项
export const stepTypes = [
  { value: 'MESSAGE', label: '消息（1v1私聊和社群）', icon: 'MessageOutlined', description: '本功能将由企业微信统一发送，客户每天可以收到1次,建议发送时间不要集中在整点,以免被企微限流' },
  { value: 'MOMENTS', label: '朋友圈', icon: 'GlobalOutlined', description: '成员收到提醒后,在群发助手中,成员点击"发送"按钮一键发送。一天不限次数发送，用户可能会刷到5-7条,请勿设定大量同一时间的SOP,企微一分钟内仅支持创建10条朋友圈SOP内容,请在设置时间时,以分钟为单位错开,如：8点31一部分,8点32一部分,一方面模拟真人发圈效果,一方面避免企微限流,不支持企业微信好友。' },
  // { value: 'TAG', label: '更新标签', icon: 'TagOutlined', disabled: true }
];

// 消息类型选项（根据企业微信API调整）
export const messageTypes = [
  { value: 'TEXT', label: '文本消息', icon: 'MessageOutlined' },
  { value: 'IMAGE', label: '图片消息', icon: 'FileImageOutlined' },
  { value: 'IMAGE_GROUP', label: '图片', icon: 'FileImageOutlined', description: '一次发送多张图片，最多9张' },
  { value: 'VIDEO', label: '视频消息', icon: 'VideoCameraOutlined' },
  { value: 'LINK', label: '链接消息', icon: 'LinkOutlined' },
  { value: 'MINIPROGRAM', label: '小程序消息', icon: 'AppstoreOutlined' },
  { value: 'FILE', label: '文件消息', icon: 'FileOutlined' }
];

// 朋友圈内容类型选项
export const momentTypes = [
  { value: 'MOMENT_TEXT', label: '文本内容', icon: 'MessageOutlined' },
  { value: 'MOMENT_IMAGE', label: '图片内容', icon: 'FileImageOutlined' },
  { value: 'MOMENT_IMAGE_GROUP', label: '图片', icon: 'FileImageOutlined', description: '一次发送多张图片，最多9张' },
  { value: 'MOMENT_VIDEO', label: '视频内容', icon: 'VideoCameraOutlined' },
  { value: 'MOMENT_LINK', label: '链接内容', icon: 'LinkOutlined' }
];

// 朋友圈附件类型
export const momentsAttachmentTypes = [
  { value: 'IMAGES', label: '图片', icon: 'FileImageOutlined' },
  { value: 'VIDEO', label: '视频', icon: 'VideoCameraOutlined' },
  { value: 'LINK', label: '链接', icon: 'LinkOutlined' }
];

// 添加一个emoji数据集
export const emojiData = [
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', 
  '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', 
  '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩',
  '👍', '👎', '👏', '🙌', '👌', '✌️', '🤞', '🤟', '🤘', '👊',
  '💪', '🙏', '🤝', '💯', '❤️', '🔥', '👨‍💻', '🎉', '🎊', '🎁'
]; 